"use client";
import { useState } from "react";
import Image, { ImageProps } from "next/image";
import { Spin } from "@/components/ui-feat/spin";
import { cn } from "@/utils/classnames";

export interface SkeletonImageProps extends ImageProps {
  skeletonWidth?: number;
  skeletonHeight?: number;
  skeletonClassName?: string;
  /** 视口扩展边距，格式：'top right bottom left'，默认 '0px 0px 0px 0px' */
  rootMargin?: string;
  /** 是否只触发一次（进入后停止监听），默认 true（优化性能） */
  once?: boolean;
}

function ImageLoad(props: SkeletonImageProps) {
  const {
    skeletonWidth = 70,
    skeletonHeight = 38,
    skeletonClassName = '',
    className,
    ...imageProps
  } = props;
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={cn("relative w-full h-full", className)}>
      {/* 骨架屏 shimmer 效果 */}
      {!loaded && (
        <Spin
          className={cn("w-full h-full", skeletonClassName)}
          logoWidth={skeletonWidth}
          logoHeight={skeletonHeight}
        />
      )}

      <Image
        loading="eager"
        {...imageProps}
        className={cn(loaded ? "opacity-100" : "opacity-0", "transition-opacity duration-300", className)}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}

export default ImageLoad;
